export const sayHello = x => console.log(`Hello: ${x}`);
